<template>

<div>

    <fieldset class="fieldset h-100 mb-0">

        <h3 class="fieldset-title"> {{ $parent.phase.type == "auction" ? "Търгът" : "Конкурсът" }} за {{ $parent.phase.name }} приключи. </h3> 

        <div class='row' v-if='isReady && winner'>
            <div class='col-12 text-center'>
                За победител е избран:  <br>
                <strong> {{ winner.name }} </strong>
                <h6>Успех следващия път!</h6>
            </div>
            <div class='col-12' v-if='winner.place'>
                <p>
                    Твоят проект е класиран сред трите най-добри идейни предложения на конкурса. <br>
                    <strong> Възложителят те класира на {{ winner.place == 2 ? '2-ро' : '3-то' }} място </strong>

                    <strong>
                        Твоята награда е : 
                        <span v-if='winner.place == 2'>
                            {{ $store.state.ip.detiled.second_place }} лв.
                        </span>
                        <span v-if='winner.place == 3'>
                            {{ $store.state.ip.detiled.third_place }} лв.
                        </span>
                    </strong>
                </p>
            </div>
        </div>

    </fieldset>

    <loading-div v-if='!isReady'></loading-div>

    <div v-if='isReady && !winner' class='col-12 alert alert-danger'>
        Възникна проблем. Моля опитайте отново след минута.
    </div>

    <div v-if='isReady && winner === 0' class='col-12 alert alert-info'>
        Все още няма обявен победител за този {{ $parent.phase.type == "auction" ? "Търг" : "Конкурс" }}.
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

            this.getData();

        },

        created() {
           
        },

        data() {
            
            return {
                isReady : false,
                winner  : false,
            }

        },

        methods : {

            //Get winner information
            getData() {
                var me = this;

                me.ajax.call('phs:gwi', { pp : this.$parent.projectPhase.id }, (r) => {

                    if( r.status == 'success' ) {

                        if( r.data ) {
                        
                            me.winner = r.data;
                        
                        } else {
                            
                            me.winner = 0;

                        }
                    }

                    me.isReady = true;

                })
            }

        }

    }
</script>
